export const AvatarEvents = {
    DRAG_START_EVENT: 'dragStart',
    DRAG_MOVE_EVENT: 'dragMove',
    DRAG_END_EVENT: 'dragEnd',
    ROTATE_START_EVENT: 'rotateStart',
    ROTATE_MOVE_EVENT: 'rotateMove',
    ROTATE_END_EVENT: 'rotateEnd'
};
